module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"depot":"Depot"},"es":{"depot":"Estación de molienda"},"sw":{"depot":"Mwanaume"}}')
  delete Component.options._Ctor
}
